module.exports = __webpack_public_path__ + "static/media/ic-logout.72fa8110.svg";